<script>
  import { Block, Image } from 'bastone'

  export let user = null
  export let size = '2rem'
  export let vSize = '0.8rem'

</script>


<Block position=relative overflow=hidden zIndex=0>
  <Image url={user?.avatar} radius=50% height={size} width={size}></Image>
  {#if user && user.is_pro}
  <Block position=absolute bottom=0 right=0 zIndex=1>
    <Image url='/images/verified.png' height={vSize}/>
  </Block>
  {/if}
</Block>